import React, { useState, useEffect } from "react";
import { MultiSelect } from 'primereact/multiselect';
import { setProducts } from 'src/redux/actions';
import { useDispatch, useSelector } from 'react-redux';

export default function Product(props) {
  const [selectAll, setSelectAll] = useState(true);
  const dispatch = useDispatch();
  const products = useSelector((state) => state.filter.products) || [];
  const items = Array.from(Object.keys(props.remote_source), key => ({
    label: props.remote_source[key],
    value: key,
  }));

  const handleProductsChange = (e) => {
    console.log("New Products:", e.value);
    dispatch(setProducts(e.value));
  };

  return (
    <div className="card flex justify-content-center" style={{ border: 'none' }}>
      <label className="control-label justify-content-start" htmlFor={props.id}>
        {props.label}
      </label>
      <MultiSelect
        value={products}
        options={items}
        onChange={handleProductsChange}
        filter
        virtualScrollerOptions={{ itemSize: 30, height: '100px'  }}
        maxSelectedLabels={1}
        placeholder={"Select " + props.label}
        className="w-full md:w-20rem"
        panelStyle={{ maxHeight: '300px', overflow: 'auto' }} // Adjust the maxHeight and overflow
      />
    </div>
  );
}
